import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../Features/Postes/Slice/authSlice";
import doctorAuthReducer from "../Features/Postes/Slice/doctorAuthSlice/doctorAuthSlice";
import patientFlowReducer from "../Features/Postes/Slice/patientFlowSlice";
import doctorExpertiseReducer from "../Features/Postes/Slice/doctorExpertiseSlice";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    doctorAuth: doctorAuthReducer,
    patientFlow: patientFlowReducer,
    doctorExpertise: doctorExpertiseReducer,

  },
});